import React from 'react';
import { Navigate } from 'react-router-dom';

export default function ProtectedRoute({ tipoPermitido, children }) {
  const tipoUsuario = localStorage.getItem('tipoUsuario');
  const idUsuario = localStorage.getItem('idUsuario');

  // Verifica se o usuário está autenticado
  if (!tipoUsuario || !idUsuario) {
    //console.log('Usuário não autenticado - Redirecionando para login');
    return <Navigate to="/" />;
  }

  // Verifica se o tipo de usuário corresponde ao permitido
  if (tipoUsuario !== tipoPermitido) {
    //console.log(`Tipo de usuário (${tipoUsuario}) não corresponde ao permitido (${tipoPermitido})`);
    return <Navigate to="/" />;
  }

  return children;
} 